import { create, StoreApi, UseBoundStore } from "zustand";
import { createJSONStorage, persist } from "zustand/middleware";

import { createAuthSlice } from "./auth";
import { AppState } from "./types";

const useStore = create<AppState>()(
  persist(
    (...a) => ({
      ...createAuthSlice(...a),
    }),
    {
      name: "root-store",
      storage: createJSONStorage(() => localStorage),
    },
  ),
);

type Selectors<Store> = Store extends { getState: () => infer Type }
  ? Store & { use: { [Key in keyof Type]: () => Type[Key] } }
  : never;

export const createSelectors = <Store extends UseBoundStore<StoreApi<object>>>(
  _store: Store,
) => {
  const store = _store as Selectors<typeof _store>;
  store.use = {};

  for (const key of Object.keys(store.getState())) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (store.use as any)[key] = () =>
      store((state) => state[key as keyof typeof state]);
  }

  return store;
};

export default useStore;
